// extracted by mini-css-extract-plugin
export var container = "_f6-1";
export var editor = "_f6-2";
export var resizable = "_f6-3";
export var wrapper = "_f6-0";